var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZilappIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 177,
    viewBox: "0 0 177 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176.213,
    height: 176.213,
    fill: "#333444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.918 40.4409L106.941 96.0428L111.129 96.0774C122.186 96.1093 131.081 105.171 130.914 116.226C130.749 127.069 121.914 135.772 111.07 135.772L45.3376 135.75L71.9148 79.5347H64.8406C54.0456 79.5341 45.2947 70.7818 45.2947 59.9867C45.2953 49.1921 54.046 40.4415 64.8406 40.4409H130.918ZM53.9592 59.9867C53.9592 65.9966 58.8309 70.8696 64.8406 70.8702H85.5948L59.0175 127.086L111.07 127.107C117.179 127.107 122.158 122.204 122.252 116.095C122.346 109.866 117.331 104.76 111.102 104.742H111.097L93.7896 104.661L117.746 49.1054H64.8406C58.8312 49.1059 53.9598 53.9774 53.9592 59.9867Z",
    fill: "#FF6347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilappIcn);
export default __webpack_public_path__ + "static/media/zilapp_icn.d25bde4d010f7d2fef3ae269b9956cee.svg";
export { ForwardRef as ReactComponent };